// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var Calendar = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M4.5 7a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5M7.5 7a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5M10.5 7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1 8h10.5a.5.5 0 0 1 0 1H1zm0 3h7.5a.5.5 0 0 1 0 1H1zM1 5h14v1H1z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.5 1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5M11.5 1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5M14.5 11a.5.5 0 0 1 .492.41l.008.09v1a2.5 2.5 0 0 1-2.336 2.495L12.5 15h-3a.5.5 0 0 1-.09-.992L9.5 14h3a1.5 1.5 0 0 0 1.493-1.356L14 12.5v-1a.5.5 0 0 1 .5-.5"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13 3a2 2 0 0 1 2 2v3c0 2-2 3-4 3q1 2-1 4H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm.117 1.007L13 4H3a1 1 0 0 0-.993.883L2 5v8a1 1 0 0 0 .883.993L3 14h6.566l.031-.033c.738-.856.9-1.608.575-2.375l-.067-.144a1 1 0 0 1 .894-1.447c1.692 0 2.9-.76 2.994-1.861l.006-.139v-3a1 1 0 0 0-.883-.993z"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(Calendar);
export default ForwardRef;
